import axios from "axios";
import { TASK_LIST_URL, TASK_SLA_UPDATE_URL } from "../config/apiConstants";
import { prepareRequestparams } from "../helpers/requestHelpders";

export async function getTasks(sort, filter, page, include) {
  return await axios.get(
    TASK_LIST_URL,
    prepareRequestparams(sort, filter, page, include),
  );
}

export async function getAssigneeWorkingIntervals(params) {
  return await axios.get(`${TASK_LIST_URL}/sla/work_intervals`, {
    params: params,
  });
}

export async function updateTaskSla(taskId, data) {
  return await axios.patch(`${TASK_SLA_UPDATE_URL}/${taskId}`, data);
}
